// extracted by mini-css-extract-plugin
export var aboutMe = "styles-module--aboutMe--yOfLC";
export var profileWrapper = "styles-module--profileWrapper--NQUPb";
export var profilePhotoWrapper = "styles-module--profilePhotoWrapper--+uJS9";
export var profilePhoto = "styles-module--profilePhoto--Bvik8";
export var profileTextDiv = "styles-module--profileTextDiv--WdHaZ";